import { render, staticRenderFns } from "./scanInfo.vue?vue&type=template&id=c38b883e&scoped=true&"
import script from "./scanInfo.vue?vue&type=script&lang=js&"
export * from "./scanInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38b883e",
  null
  
)

export default component.exports